import { render } from "./ManageArchive.vue?vue&type=template&id=1fa92896"
import script from "./ManageArchive.vue?vue&type=script&lang=js"
export * from "./ManageArchive.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__